/**
 * @file pluginHelper.js
 * @author Geoffrey Pursell
 * @desc Contains functions that
 */

define('cardboard/pluginHelper',[
  // libraries
  "jquery",
  "underscore",
  "underscore.string",
  "backbone",
  "rsvp",

  //app modules
  "plugins/all",
  "commonDataSources",

  // templates
  "text!templates/error.html!strip",
  "text!templates/orgInfo.html!strip",
], function (
  $,
  _,
  _s,
  Backbone,
  RSVP,
  Plugins,
  CommonDataSources,
  errorTemplate,
  orgInfoTemplate
) {
  console.log("MODULE: cardboard/pluginHelper");

  // var Promise = RSVP.Promise;

  var allPlugins = Plugins.plugins,
    aliases = Plugins.aliases;

  /**
   * @exports cardboard/pluginHelper
   * @desc Functions that the app can use to query available plugins and whatnot.
   */
  var exports = {
    // PRIVATE METHODS

    addErrorPane: function (pluginInfo) {
      if (!pluginInfo || !pluginInfo.panes) {
        return;
      }

      // here, we make sure that every plugin has a functioning error pane.
      // but we don't want to add one if it's already there.
      var hasErrorPaneAlready = !!_(pluginInfo.panes).find(function (pane) {
        return pane.type === "errorPane";
      });

      if (hasErrorPaneAlready) {
        return;
      }

      pluginInfo.panes.push({
        title: "Errors",
        type: "errorPane",
        views: [
          {
            type: "template",
            template: errorTemplate,
          },
        ],
      });
    },

    addOrgDetailPane: function (pluginInfo) {
      if (!pluginInfo || !pluginInfo.panes) {
        return;
      }

      // here, we make sure that every plugin has a functioning error pane.
      // but we don't want to add one if it's already there.
      var hasPaneAlready = !!_(pluginInfo.panes).find(function (pane) {
          return pane.type === "errorPane";
        }),
        hasDataSourceAlready = !!pluginInfo.dataSources.orgDetail;

      var title = "<span class='msg_schCont'>School Contact Information</span>";
      if (pluginInfo.options.contactTitle)
        title = "<span class=''>Head Start Agency Contact Information</span>";

      if (!hasPaneAlready) {
        pluginInfo.panes.push({
          title: title, 
          openByDefault: true,
          views: [
            {
              type: "template",
              template: orgInfoTemplate,
              dataSourceName: "orgDetail",
            },
          ],
        });
      }
      if (!hasDataSourceAlready) {
        pluginInfo.dataSources.orgDetail = CommonDataSources.orgDetail;
      }
    },

    // PUBLIC METHODS

    /** method: return a requested plugin, even if the
     * requested name is just an alias
     * @param id {Object|String} the plugin to get, given as either its
     * string ID, or a model object from the report list view */
    getPlugin: function (requestedPlugin) {
      var id, plugin;

      if (_(requestedPlugin).isObject()) {
        id = requestedPlugin.get("url");
      } else {
        // its' a string ID
        id = requestedPlugin;
      }

      // if we find the plugin, great
      if (allPlugins[id]) {
        plugin = allPlugins[id];
      }
      // if not, check the aliases list
      else if (aliases[id]) {
        plugin = allPlugins[aliases[id]];
      }
      // if that fails, something is horribly wrong
      else {
        plugin = undefined;
        throw {
          name: "Plugin Error",
          message: "Plugin " + id + " not yet implemented.",
        };
      }

      // every plugin gets an error plane, and the org info data source and pane
      if (
        !plugin.options ||
        (plugin.options && plugin.options.orgDetailPane !== false)
      ) {
        this.addOrgDetailPane(plugin);
      }
      this.addErrorPane(plugin);

      return plugin;
    },

    // PLUGIN INFO FUNCTIONS

    pluginExists: function (id) {
      try {
        return !!this.getPlugin(id);
      } catch (e) {
        return false;
      }
    },
    /**
     * retrieves the current plugin object
     * @returns {object} the current plugin object
     */
    getCurrentPlugin: function () {
      return this.getPlugin(window.workspace.getCurrentPluginName());
    },
    /**
     * retrieves the current plugin's options
     * @returns {object} the current plugin's options hash; if none, ane empty object
     */
    getCurrentPluginOptions: function () {
      var plugin = this.getCurrentPlugin();
      return plugin.options ? plugin.options : {};
    },
    getCurrentPluginDataSources: function () {
      return this.getCurrentPlugin().dataSources;
    },
    getCurrentPluginFilterSources: function () {
      return _(this.getCurrentPlugin().filterSources)
        .pick(function (source) {
          return source.noViewParams !== true;
        })
        .value();
    },
    getCurrentPluginSharedFilterSources: function () {
      return _(this.getCurrentPlugin().filterSources)
        .omit(function (source) {
          return source.noViewParams !== true;
        })
        .value();
    },
    getAllPlugins: function () {
      return this.plugins;
    },
    getCurrentPluginDemoCatsOptions: function () {
      var currentPlugin = this.getCurrentPlugin();
      var currentPluginOptions = currentPlugin.options || {};
      var demoCatsOptions = currentPluginOptions.demographicCategories || {};
      return demoCatsOptions;
    },
  };

  return exports;
});

